/* eslint-disable camelcase */
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { object, array, bool, number, string } from "prop-types";
import get from "lodash/get";
import { getStoriesFromCollections } from "../../utils/collection";
import ShowMoreButton from "../../atoms/ShowMoreButton";
import { generateNavigateSlug, navigateTo } from "../../utils";
import { OtherStory } from "./OtherStory";
import { HeroStory } from "./HeroStory";
import CollectionTitle from "../../atoms/CollectionTitle";
import { RowSeparator } from "../../atoms/RowSeparator";
import { DfpComponent } from "../../ads/dfp-component";

import "./three-col-twelve-or-eighteen-stories.m.css";

const Column = ({
  collection,
  showColumnSeparator,
  showStorySeparator,
  showTimestamp,
  showReadTime,
  showColumnTitle,
  numberOfStoriesToShow,
  showMoreStories,
  config,
  showSubheadline,
  sectionSlug,
}) => {
  const dispatch = useDispatch();
  const qtConfig = useSelector((state) => get(state, ["qt", "config"], {}));
  const url = generateNavigateSlug(collection, qtConfig);

  const stories = getStoriesFromCollections(collection, numberOfStoriesToShow);
  if (stories.length < 1) {
    return null;
  }
  return (
    <div
      styleName="column"
      style={{ borderBottom: showStorySeparator || "none", borderRight: showColumnSeparator || "none" }}
    >
      {showColumnTitle && (
        <CollectionTitle collection={collection} containerStyles={"row-title"} sectionSlug={sectionSlug} />
      )}
      <HeroStory
        story={stories[0]}
        showSubheadline={showSubheadline}
        showReadTime={showReadTime}
        showTimestamp={showTimestamp}
        showSeparator={showStorySeparator && stories.length > 1}
        showPadding={stories.length > 1}
        sectionSlug={sectionSlug}
      />
      {stories.slice(1).map((story) => {
        return (
          <OtherStory
            story={story}
            key={story.id}
            showBorder={showStorySeparator}
            showTimestamp={showTimestamp}
            showReadTime={showReadTime}
            sectionSlug={sectionSlug}
          />
        );
      })}
      {stories.length > 0 && showMoreStories && (
        <ShowMoreButton
          collection={collection}
          config={config}
          navigate={() => navigateTo(dispatch, url)}
          qtConfig={qtConfig}
          customStyleName={"top-margin"}
        />
      )}
    </div>
  );
};

Column.propTypes = {
  config: object,
  collection: object,
  showStorySeparator: bool,
  showColumnSeparator: bool,
  showTimestamp: bool,
  showReadTime: bool,
  showColumnTitle: bool,
  showSubheadline: bool,
  numberOfStoriesToShow: number,
  showMoreStories: bool,
  sectionSlug: string,
};

export const ThreeColTwelveOrEighteenStories = ({ config, collection, stories, extraProp = "" }) => {
  const {
    show_timestamp,
    show_read_time,
    show_subheadline_of_first_story,
    show_column_title,
    show_column_separator,
    show_row_separator,
    show_story_separator,
    show_more_stories_button,
    show_remaining_stories,
    show_row_ad_unit_bottom,
  } = get(collection, ["associated-metadata"], {});
  const pageType = useSelector((state) => get(state, ["qt", "pageType"], null));
  const bottomAdConfig = useSelector((state) =>
    get(state, ["qt", "config", "ads-config", "slots", "row_bottom_ad"], {})
  );
  const rowAdBottom = show_row_ad_unit_bottom?.split("/").slice(-1)[0];
  const rowAdBottomDivId = useSelector((state) =>
    get(state, ["qt", "config", "ads-config", "ad_div_mapping", rowAdBottom], "")
  );
  const filteredCollection = get(collection, ["items"], [])
    .slice(0, 3)
    .map((collections) => {
      return collections.type === "collection" ? collections : [];
    });

  const sectionSlug = extraProp;

  if (filteredCollection.length < 1) {
    return null;
  }
  return (
    <div className="row-component" styleName="three-col-twelve-or-eighteen-stories">
      <div styleName="columns">
        {filteredCollection.map((item) => (
          <Column
            key={item.id}
            collection={item}
            showTimestamp={show_timestamp}
            showReadTime={show_read_time}
            showColumnTitle={show_column_title}
            showSubheadline={show_subheadline_of_first_story}
            showStorySeparator={show_story_separator}
            showColumnSeparator={show_column_separator}
            numberOfStoriesToShow={show_remaining_stories ? 6 : 4}
            showMoreStories={show_more_stories_button && !show_remaining_stories}
            config={config}
            sectionSlug={sectionSlug}
          />
        ))}
      </div>
      {show_row_separator && <RowSeparator />}
      <DfpComponent adStyleName="ad-slot-size-300x250" id={rowAdBottomDivId} />
    </div>
  );
};

ThreeColTwelveOrEighteenStories.propTypes = {
  config: object,
  collection: object,
  stories: array,
  extraProp: string,
};
